//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.NullableBooleanAdapter
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.apollographql.apollo.api.present
import com.wintermar.inspection.graphql.type.UpsertInspectionCommandInput
import kotlin.IllegalStateException

public object UpsertInspectionCommandInput_InputAdapter : Adapter<UpsertInspectionCommandInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): UpsertInspectionCommandInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: UpsertInspectionCommandInput,
  ) {
    writer.name("id")
    AnyAdapter.toJson(writer, customScalarAdapters, value.id)
    writer.name("inspectionId")
    AnyAdapter.toJson(writer, customScalarAdapters, value.inspectionId)
    writer.name("questionId")
    AnyAdapter.toJson(writer, customScalarAdapters, value.questionId)
    if (value.answer is Optional.Present) {
      writer.name("answer")
      NullableStringAdapter.present().toJson(writer, customScalarAdapters, value.answer)
    }
    if (value.optionId is Optional.Present) {
      writer.name("optionId")
      NullableAnyAdapter.present().toJson(writer, customScalarAdapters, value.optionId)
    }
    if (value.isFlagged is Optional.Present) {
      writer.name("isFlagged")
      NullableBooleanAdapter.present().toJson(writer, customScalarAdapters, value.isFlagged)
    }
    if (value.notes is Optional.Present) {
      writer.name("notes")
      NullableStringAdapter.present().toJson(writer, customScalarAdapters, value.notes)
    }
    if (value.findingCategory is Optional.Present) {
      writer.name("findingCategory")
      FindingCategory_ResponseAdapter.nullable().present().toJson(writer, customScalarAdapters, value.findingCategory)
    }
    if (value.media is Optional.Present) {
      writer.name("media")
      InspectionMediaDtoInput_InputAdapter.obj().list().nullable().present().toJson(writer, customScalarAdapters, value.media)
    }
  }
}
